import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import deliveryProcessPage from "./assets/Delivery process page.png";
import deviceIssuedConfirmation from "./assets/Device issued confirmation.png";
import issueDeviceButton from "./assets/Issue device button.png";
import issueDeviceConfirmationPage from "./assets/Issue device confimation page.png";
export const RequestDeviceSection: React.FC = () => {
  return (
    <Doc.Section title="Request Device">
      <p>To be able to request a device for the patient, the “Issue device” button needs to be pressed.</p>
      <Doc.Illustration src={issueDeviceButton} label="Issue device button" />
      <p>Click on the “Issue device” button to open the Issue device page.</p>
      <Doc.Note>
        <strong>Please note:</strong> To be able to issue a device to the patient your user profile must have
        corresponding permissions. The link will not be visible if access to this functionality is not allowed for your
        user profile. If such situation occurs and you need access to this functionality, please contact the Entia
        support team.
      </Doc.Note>
      <Doc.Illustration src={deliveryProcessPage} label="Delivery process page" />
      <p>
        This page contains an explanation of the next steps which will happen when the issue device process is
        triggered:
      </p>
      <ul>
        <li> The device will be delivered to a patient within 7 days</li>
        <li>The patient will be trained to use the device by Entia</li>
        <li>Results are displayed in the Entia Liberty Patient List</li>
      </ul>
      <p>After clicking on the “Continue to Confirmation” button, the confirmation page will be opened.</p>
      <Doc.Illustration src={issueDeviceConfirmationPage} label="Issue device confirmation page" />

      <p>
        Clicking the “Issue Device” button will open the Review Patient page. The information about the issued device
        will be presented in the Device Details section on the Review Patient page. Clicking on the “Cancel” button will
        also open the Review Patient page with no device issued for the patient.
      </p>
      <Doc.Illustration src={deviceIssuedConfirmation} label="Device issued confirmation" />
    </Doc.Section>
  );
};
